import { useContext } from "react";

import { AuthContext } from "@/contexts/auth";

import styles from "./index.module.scss";

type Props = {
  children: React.ReactNode;
  className?: string;
  isNormalPadding?: boolean; //サマリーアカウントでも通常のpaddingを使いたい場合にtrue
};

const Wrapper: React.FC<Props> = ({ children, className, isNormalPadding }) => {
  const { summaryAccounts } = useContext(AuthContext);
  return (
    <div
      id="wrapper"
      className={[
        summaryAccounts.account_type !== "normal" && !isNormalPadding
          ? styles.wrapper_summary
          : styles.wrapper,
        className
      ].join(" ")}
    >
      {children}
    </div>
  );
};

export default Wrapper;
